import Cookies from 'js-cookie';

export const getHeaders = (): Record<string, string> => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${Cookies.get("authToken") || ''}`,
    "X-INSTITUTE": Cookies.get("ins_code") || '',
    "X-E-ID": Cookies.get("E_id") || '',
    "X-FACULTY": "1",
    "X-PARENT": Cookies.get("ins_code") || '',
});